function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    <style>\n      :host {\n        @apply --layout-vertical;\n        position: relative;\n        height: 100%;\n        @apply --paper-header-panel;\n      }\n\n      #mainContainer {\n        @apply --layout-flex;\n        position: relative;\n        overflow-y: auto;\n        overflow-x: hidden;\n        -webkit-overflow-scrolling: touch;\n      }\n\n      #mainPanel {\n        @apply --layout-vertical;\n        @apply --layout-flex;\n        position: relative;\n        min-height: 0;\n        @apply --paper-header-panel-body;\n      }\n\n      #mainContainer {\n        @apply --paper-header-panel-container;\n      }\n\n      /*\n       * mode: scroll\n       */\n      :host([mode=scroll]) #mainContainer {\n        @apply --paper-header-panel-scroll-container;\n        overflow: visible;\n      }\n\n      :host([mode=scroll]) {\n        overflow-y: auto;\n        overflow-x: hidden;\n        -webkit-overflow-scrolling: touch;\n      }\n\n      /*\n       * mode: cover\n       */\n      :host([mode=cover]) #mainContainer {\n        @apply --paper-header-panel-cover-container;\n        position: absolute;\n        top: 0;\n        right: 0;\n        bottom: 0;\n        left: 0;\n      }\n\n      :host([mode=cover]) #mainPanel {\n        position: static;\n      }\n\n      /*\n       * mode: standard\n       */\n      :host([mode=standard]) #mainContainer {\n        @apply --paper-header-panel-standard-container;\n      }\n\n      /*\n       * mode: seamed\n       */\n      :host([mode=seamed]) #mainContainer {\n        @apply --paper-header-panel-seamed-container;\n      }\n\n\n      /*\n       * mode: waterfall\n       */\n      :host([mode=waterfall]) #mainContainer {\n        @apply --paper-header-panel-waterfall-container;\n      }\n\n      /*\n       * mode: waterfall-tall\n       */\n      :host([mode=waterfall-tall]) #mainContainer {\n        @apply --paper-header-panel-waterfall-tall-container;\n      }\n\n      #dropShadow {\n        transition: opacity 0.5s;\n        height: 6px;\n        box-shadow: inset 0px 5px 6px -3px rgba(0, 0, 0, 0.4);\n        @apply --paper-header-panel-shadow;\n        position: absolute;\n        top: 0;\n        left: 0;\n        right: 0;\n        opacity: 0;\n        pointer-events: none;\n      }\n\n      #dropShadow.has-shadow {\n        opacity: 1;\n      }\n\n      #mainContainer > ::slotted(.fit) {\n        @apply --layout-fit;\n      }\n\n    </style>\n\n    <slot id=\"headerSlot\" name=\"header\"></slot>\n\n    <div id=\"mainPanel\">\n      <div id=\"mainContainer\" class$=\"[[_computeMainContainerClass(mode)]]\">\n        <slot></slot>\n      </div>\n      <div id=\"dropShadow\"></div>\n    </div>\n"], ["\n    <style>\n      :host {\n        @apply --layout-vertical;\n        position: relative;\n        height: 100%;\n        @apply --paper-header-panel;\n      }\n\n      #mainContainer {\n        @apply --layout-flex;\n        position: relative;\n        overflow-y: auto;\n        overflow-x: hidden;\n        -webkit-overflow-scrolling: touch;\n      }\n\n      #mainPanel {\n        @apply --layout-vertical;\n        @apply --layout-flex;\n        position: relative;\n        min-height: 0;\n        @apply --paper-header-panel-body;\n      }\n\n      #mainContainer {\n        @apply --paper-header-panel-container;\n      }\n\n      /*\n       * mode: scroll\n       */\n      :host([mode=scroll]) #mainContainer {\n        @apply --paper-header-panel-scroll-container;\n        overflow: visible;\n      }\n\n      :host([mode=scroll]) {\n        overflow-y: auto;\n        overflow-x: hidden;\n        -webkit-overflow-scrolling: touch;\n      }\n\n      /*\n       * mode: cover\n       */\n      :host([mode=cover]) #mainContainer {\n        @apply --paper-header-panel-cover-container;\n        position: absolute;\n        top: 0;\n        right: 0;\n        bottom: 0;\n        left: 0;\n      }\n\n      :host([mode=cover]) #mainPanel {\n        position: static;\n      }\n\n      /*\n       * mode: standard\n       */\n      :host([mode=standard]) #mainContainer {\n        @apply --paper-header-panel-standard-container;\n      }\n\n      /*\n       * mode: seamed\n       */\n      :host([mode=seamed]) #mainContainer {\n        @apply --paper-header-panel-seamed-container;\n      }\n\n\n      /*\n       * mode: waterfall\n       */\n      :host([mode=waterfall]) #mainContainer {\n        @apply --paper-header-panel-waterfall-container;\n      }\n\n      /*\n       * mode: waterfall-tall\n       */\n      :host([mode=waterfall-tall]) #mainContainer {\n        @apply --paper-header-panel-waterfall-tall-container;\n      }\n\n      #dropShadow {\n        transition: opacity 0.5s;\n        height: 6px;\n        box-shadow: inset 0px 5px 6px -3px rgba(0, 0, 0, 0.4);\n        @apply --paper-header-panel-shadow;\n        position: absolute;\n        top: 0;\n        left: 0;\n        right: 0;\n        opacity: 0;\n        pointer-events: none;\n      }\n\n      #dropShadow.has-shadow {\n        opacity: 1;\n      }\n\n      #mainContainer > ::slotted(.fit) {\n        @apply --layout-fit;\n      }\n\n    </style>\n\n    <slot id=\"headerSlot\" name=\"header\"></slot>\n\n    <div id=\"mainPanel\">\n      <div id=\"mainContainer\" class\\$=\"[[_computeMainContainerClass(mode)]]\">\n        <slot></slot>\n      </div>\n      <div id=\"dropShadow\"></div>\n    </div>\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

/**
@license
Copyright (c) 2015 The Polymer Project Authors. All rights reserved.
This code may only be used under the BSD style license found at
http://polymer.github.io/LICENSE.txt The complete set of authors may be found at
http://polymer.github.io/AUTHORS.txt The complete set of contributors may be
found at http://polymer.github.io/CONTRIBUTORS.txt Code distributed by Google as
part of the polymer project is also subject to an additional IP rights grant
found at http://polymer.github.io/PATENTS.txt
*/
import '@polymer/polymer/polymer-legacy.js';
import '@polymer/iron-flex-layout/iron-flex-layout.js';
import { Polymer } from '@polymer/polymer/lib/legacy/polymer-fn.js';
import { dom } from '@polymer/polymer/lib/legacy/polymer.dom.js';
import { html } from '@polymer/polymer/lib/utils/html-tag.js';
var SHADOW_WHEN_SCROLLING = 1;
var SHADOW_ALWAYS = 2;
var MODE_CONFIGS = {
  outerScroll: {
    'scroll': true
  },
  shadowMode: {
    'standard': SHADOW_ALWAYS,
    'waterfall': SHADOW_WHEN_SCROLLING,
    'waterfall-tall': SHADOW_WHEN_SCROLLING
  },
  tallMode: {
    'waterfall-tall': true
  }
};
/**
**This element has been deprecated in favor of
[app-layout](https://github.com/PolymerElements/app-layout).**

`paper-header-panel` contains a header section and a content panel section.

__Important:__ The `paper-header-panel` will not display if its parent does not
have a height.

Using layout classes, you can make the `paper-header-panel` fill the screen

    <body class="fullbleed layout vertical">
      <paper-header-panel class="flex">
        <paper-toolbar slot="header">
          <div>Hello World!</div>
        </paper-toolbar>
      </paper-header-panel>
    </body>

Special support is provided for scrolling modes when one uses a paper-toolbar or
equivalent for the header section.

Example:

    <paper-header-panel>
      <paper-toolbar slot="header">Header</paper-toolbar>
      <div>Content goes here...</div>
    </paper-header-panel>

To have the content fit to the main area, use the `fit` class.

Example:

    <paper-header-panel>
      <div slot="header">standard</div>
      <div class="fit">content fits 100% below the header</div>
    </paper-header-panel>

### Modes

Controls header and scrolling behavior. Options are `standard`, `seamed`,
`waterfall`, `waterfall-tall`, `scroll` and `cover`. Default is `standard`.

Mode | Description
----------------|-------------
`standard` | The header is a step above the panel. The header will consume the panel at the point of entry, preventing it from passing through to the opposite side.
`seamed` | The header is presented as seamed with the panel.
`waterfall` | Similar to standard mode, but header is initially presented as seamed with panel, but then separates to form the step.
`waterfall-tall` | The header is initially taller (`tall` class is added to the header). As the user scrolls, the header separates (forming an edge) while condensing (`tall` class is removed from the header).
`scroll` | The header keeps its seam with the panel, and is pushed off screen.
`cover` | The panel covers the whole `paper-header-panel` including the header. This allows user to style the panel in such a way that the panel is partially covering the header.

### Styling

To change the shadow that shows up underneath the header:

    paper-header-panel {
      --paper-header-panel-shadow: {
          height: 6px;
          bottom: -6px;
          box-shadow: inset 0px 5px 6px -3px rgba(0, 0, 0, 0.4);
      };
    }

To change the panel container:

    paper-header-panel {
      --paper-header-panel-container: {
        border: 1px solid gray;
      };

To change the panel container in different modes:

    paper-header-panel {
      --paper-header-panel-standard-container: {
        border: 1px solid gray;
      };

      --paper-header-panel-seamed-container: {
        border: 1px solid gray;
      };

      --paper-header-panel-waterfall-container: {
        border: 1px solid gray;
      };

      --paper-header-panel-waterfall-tall-container: {
        border: 1px solid gray;
      };

      --paper-header-panel-scroll-container: {
        border: 1px solid gray;
      };

      --paper-header-panel-cover-container: {
        border: 1px solid gray;
      };
    }

The following custom properties and mixins are available for styling:

Custom property | Description | Default
----------------|-------------|----------
`--paper-header-panel` | Mixin applied to the element | `{}`
`--paper-header-panel-body` | Mixin applied to the element's body (i.e. everything below the toolbar) | `{}`
`--paper-header-panel-container` | Mixin applied to the container in any mode | `{}`
`--paper-header-panel-scroll-container` | Mixin applied to the container when in scroll mode | `{}`
`--paper-header-panel-cover-container` | Mixin applied to the container when in cover mode | `{}`
`--paper-header-panel-standard-container` | Mixin applied to the container when in standard mode | `{}`
`--paper-header-panel-seamed-container` | Mixin applied to the container when in seamed mode | `{}`
`--paper-header-panel-waterfall-container` | Mixin applied to the container when in waterfall mode | `{}`
`--paper-header-panel-waterfall-tall-container` | Mixin applied to the container when in tall waterfall mode | `{}`
`--paper-header-panel-shadow` | Mixin applied to the waterfall shadow | `{}`

@group Paper Elements
@element paper-header-panel
@demo demo/index.html
@hero hero.svg
*/

Polymer({
  _template: html(_templateObject()),
  is: 'paper-header-panel',

  /**
   * Fired when the content has been scrolled. `event.detail.target` returns
   * the scrollable element which you can use to access scroll info such as
   * `scrollTop`.
   *
   *     <paper-header-panel on-content-scroll="scrollHandler">
   *       ...
   *     </paper-header-panel>
   *
   *
   *     scrollHandler: function(event) {
   *       var scroller = event.detail.target;
   *       console.log(scroller.scrollTop);
   *     }
   *
   * @event content-scroll
   */
  properties: {
    /**
     * Controls header and scrolling behavior. Options are
     * `standard`, `seamed`, `waterfall`, `waterfall-tall`, `scroll` and
     * `cover`. Default is `standard`.
     *
     * `standard`: The header is a step above the panel. The header will consume
     * the panel at the point of entry, preventing it from passing through to
     * the opposite side.
     *
     * `seamed`: The header is presented as seamed with the panel.
     *
     * `waterfall`: Similar to standard mode, but header is initially presented
     * as seamed with panel, but then separates to form the step.
     *
     * `waterfall-tall`: The header is initially taller (`tall` class is added
     * to the header).  As the user scrolls, the header separates (forming an
     * edge) while condensing (`tall` class is removed from the header).
     *
     * `scroll`: The header keeps its seam with the panel, and is pushed off
     * screen.
     *
     * `cover`: The panel covers the whole `paper-header-panel` including the
     * header. This allows user to style the panel in such a way that the panel
     * is partially covering the header.
     *
     *     <paper-header-panel mode="cover">
     *       <paper-toolbar slot="header" class="tall">
     *         <paper-icon-button icon="menu"></paper-icon-button>
     *       </paper-toolbar>
     *       <div></div>
     *     </paper-header-panel>
     */
    mode: {
      type: String,
      value: 'standard',
      observer: '_modeChanged',
      reflectToAttribute: true
    },

    /**
     * If true, the drop-shadow is always shown no matter what mode is set to.
     */
    shadow: {
      type: Boolean,
      value: false
    },

    /**
     * The class used in waterfall-tall mode.  Change this if the header
     * accepts a different class for toggling height, e.g. "medium-tall"
     */
    tallClass: {
      type: String,
      value: 'tall'
    },

    /**
     * If true, the scroller is at the top
     */
    atTop: {
      type: Boolean,
      value: true,
      notify: true,
      readOnly: true,
      reflectToAttribute: true
    }
  },
  observers: ['_computeDropShadowHidden(atTop, mode, shadow)'],
  attached: function attached() {
    this._addListener(); // Run `scroll` logic once to initialize class names, etc.


    this._keepScrollingState();
  },
  detached: function detached() {
    this._removeListener();
  },
  ready: function ready() {
    this.scrollHandler = this._scroll.bind(this);
    console.warn(this.is, 'is deprecated. Please use app-layout instead!');
  },

  /**
   * Returns the header element
   * @return {!Element|undefined}
   */
  get header() {
    return dom(this.$.headerSlot).getDistributedNodes()[0];
  },

  /**
   * Returns the scrollable element.
   * @return {!HTMLElement}
   */
  get scroller() {
    return this._getScrollerForMode(this.mode);
  },

  /**
   * Returns true if the scroller has a visible shadow.
   * @return {boolean}
   */
  get visibleShadow() {
    return this.$.dropShadow.classList.contains('has-shadow');
  },

  _computeDropShadowHidden: function _computeDropShadowHidden(atTop, mode, shadow) {
    var shadowMode = MODE_CONFIGS.shadowMode[mode];

    if (this.shadow) {
      this.toggleClass('has-shadow', true, this.$.dropShadow);
    } else if (shadowMode === SHADOW_ALWAYS) {
      this.toggleClass('has-shadow', true, this.$.dropShadow);
    } else if (shadowMode === SHADOW_WHEN_SCROLLING && !atTop) {
      this.toggleClass('has-shadow', true, this.$.dropShadow);
    } else {
      this.toggleClass('has-shadow', false, this.$.dropShadow);
    }
  },
  _computeMainContainerClass: function _computeMainContainerClass(mode) {
    // TODO:  It will be useful to have a utility for classes
    // e.g. Polymer.Utils.classes({ foo: true });
    var classes = {};
    classes['flex'] = mode !== 'cover';
    return Object.keys(classes).filter(function (className) {
      return classes[className];
    }).join(' ');
  },
  _addListener: function _addListener() {
    this.scroller.addEventListener('scroll', this.scrollHandler);
  },
  _removeListener: function _removeListener() {
    this.scroller.removeEventListener('scroll', this.scrollHandler);
  },
  _modeChanged: function _modeChanged(newMode, oldMode) {
    var configs = MODE_CONFIGS;
    var header = this.header;
    var animateDuration = 200;

    if (header) {
      // in tallMode it may add tallClass to the header; so do the cleanup
      // when mode is changed from tallMode to not tallMode
      if (configs.tallMode[oldMode] && !configs.tallMode[newMode]) {
        header.classList.remove(this.tallClass);
        this.async(function () {
          header.classList.remove('animate');
        }, animateDuration);
      } else {
        this.toggleClass('animate', configs.tallMode[newMode], header);
      }
    }

    this._keepScrollingState();
  },
  _keepScrollingState: function _keepScrollingState() {
    var main = this.scroller;
    var header = this.header;

    this._setAtTop(main.scrollTop === 0);

    if (header && this.tallClass && MODE_CONFIGS.tallMode[this.mode]) {
      this.toggleClass(this.tallClass, this.atTop || header.classList.contains(this.tallClass) && main.scrollHeight < this.offsetHeight, header);
    }
  },
  _scroll: function _scroll() {
    this._keepScrollingState();

    this.fire('content-scroll', {
      target: this.scroller
    }, {
      bubbles: false
    });
  },
  _getScrollerForMode: function _getScrollerForMode(mode) {
    return MODE_CONFIGS.outerScroll[mode] ? this : this.$.mainContainer;
  }
});